import AxiosInstance from '@/api/axios';
import { selectAgentWidgetToggle } from '@/stores/agentWidgetSlice';
import { useAppDispatch, useAppSelector } from '@/stores/hooks';
import { getClientTeam } from '@/stores/userSlice';
import { getClientId } from '@/utils/helper';
import { useEffect, useRef, useState } from 'react';
import { isAgentWidgetOpen, removeAgentIframe } from '../../utils/helper';

const clickAgentLauncher = () => {
  const launcher = document.getElementById('round-btn');
  if (launcher) launcher.click();
  return Boolean(launcher);
};

const BodyScript = () => {
  const client = getClientId();
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.users);
  const toggleRequest = useAppSelector(selectAgentWidgetToggle);
  const [enabled, setEnabled] = useState(false);
  const [clientDetails, setClientDetails] = useState<any>(null);
  const openOnLoad = useRef(false);

  useEffect(() => {
    if (!toggleRequest) {
      return;
    }
    if (clickAgentLauncher()) {
      return;
    }
    openOnLoad.current = true;
    setEnabled(true);
  }, [toggleRequest]);

  // fetch client details
  useEffect(() => {
    const fetchClientDetails = async () => {
      try {
        const response = await AxiosInstance.get(`/clients/${client}`);
        setClientDetails(response.data.data);
      } catch (error) {
        console.error('Error fetching client details:', error);
      }
    };
    if (enabled && client) {
      fetchClientDetails();
    }
  }, [enabled, client]);

  // fetch team if no user
  useEffect(() => {
    if (enabled && !user) {
      dispatch(getClientTeam());
    }
  }, [enabled, dispatch, user]);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    // clean up old script
    const oldScript = document.getElementById('embedScript');
    if (oldScript) {
      oldScript.remove();
      removeAgentIframe();
    }
    if (!user || !clientDetails) {
      return;
    }
    const script = document.createElement('script');
    script.id = 'embedScript';
    script.type = 'text/javascript';
    script.setAttribute('userid', user?.data?.user?._id || '');
    script.setAttribute('useremail', user?.data?.user?.email || '');
    script.setAttribute('organizationid', client || '');
    script.setAttribute('organizationname', clientDetails?.name || '');
    script.setAttribute('timezone', clientDetails?.timezone || '');
    script.setAttribute(
      'data-keepme-bot',
      'U2FsdGVkX1/QaGNnkEFxK0n7grlH2WWy1C2ReyrKR/fUDXdzxrbys1KTtFdhwt74hJ7GS5qK83hG4mUk7iGGNMEbpznhIcqGNKtuD+Jddd/6reUWPvy7iaR2/A0pjnFR'
    );
    script.src = 'https://agentantares.keepme.ai/bundle/embed.bundle.js';
    script.setAttribute('agenturl', import.meta.env.VITE_URL || '');

    document.body.appendChild(script);

    if (!openOnLoad.current) {
      return;
    }
    const deadline = Date.now() + 15000;
    const timer = window.setInterval(() => {
      const launcher = document.getElementById('round-btn');
      if (launcher && document.getElementById('keepmebot')) {
        openOnLoad.current = false;
        window.clearInterval(timer);
        if (!isAgentWidgetOpen()) {
          launcher.click();
        }
      } else if (Date.now() > deadline) {
        openOnLoad.current = false;
        window.clearInterval(timer);
      }
    }, 200);

    return () => {
      window.clearInterval(timer);
    };
  }, [enabled, user, clientDetails, client]);

  return null;
};

export default BodyScript;
